import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=31357988&scoped=true"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TableSkeleton.vue?vue&type=style&index=0&id=31357988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31357988",
  null
  
)

export default component.exports